const constant = {
  imgPath:"http://www.pine-soft.com/file/img/",
  videoPath:"http://www.pine-soft.com/file/video/",
  nav_list: [
    {
      name: "首页",
      router:"home",
    },
    {
      name: "产品",
      router:"productService",
    },
    // {
    //   name: "资管帮",
    //   router:"assetManagementGang",
    // },
    {
      name: "机械加工解决方案",
      router: "environment",
    },
    {
      name: "注塑冲压解决方案",
      router: "food",
    },
    {
      name: "电子电器解决方案",
      router: "engineering",
    },
    {
      name: "仓储物流解决方案",
      router: "quality",
    },
    {
      name: "客户服务",
      router:"customerService",
    },
    {
      name: "客户案例",
      router:"customerCase",
    },
    {
      name: "关于我们",
      router:"aboutUs",
    },
  ],
  slogan: "精工细作  智造未来",
  customerServiceHotline: "客服QQ ：",
  customerServiceTel: "2546125360",
  customerServiceQq: "在线客服QQ",
  groupTitle: "慧松科技培训服务团队 免费给您提供各类培训",
  groupMenus: [
    {
      name: "管理员培训",
      src:"group_manager.png",
    },
    {
      name: "应用培训",
      src:"group_app.png",
    },
    {
      name: "在线培训",
      src:"group_online.png",
    },
  ],
  groupGardTitle: "慧松科技售后服务团队 7*24贴身保障您的应用",
  groupGardDesc1: "慧松科技承诺：面对您反馈的任何问题，都做到快速响应，及时解决，您可以通过以下任意一种方式反馈：",
  groupGardDesc2: "添加客服QQ：2546125360，在线咨询或远程协助；",
  groupGardDesc3: "直接联系对接技术人员QQ；",
  groupGardDesc4: "直接联系对接销售人员。",
  tabelTitle: "售后服务响应时间",
  tableData: [
    {
      grade: '1级',
      desc: '影响功能正常使用的问题，如客户数据等无法加载，数据无法提交等',
      resptime: '10分钟',
      finishtime: '1小时'
    }, {
      grade: '2级',
      desc: '系统原因导致软件功能出现异常，但不影响正常的数据操作和提交',
      resptime: '10分钟',
      finishtime: '2小时'
    }, {
      grade: '3级',
      desc: '一般使用或操作性问题，如对系统操作不熟悉等常见问题',
      resptime: '及时响应',
      finishtime: '电话指导或即时远程协助解决问题'
    }, {
      grade: '4级',
      desc: '在系统使用过程中，对系统的建议或需求反馈',
      resptime: '10分钟',
      finishtime: '3天内给予答复（电话、QQ、邮件）'
    },
    {
      grade: '备注：7*24小时接收问题反馈。每次版本更新以及系统维护，会选择在夜间，尽力保障白天系统正常；回复时限内，若遇特殊情况，技术人员提供紧急的备选使用方案，经过客户同意，可按实际情况，跟客户确认具体的解决时间。',
      // desc: '在系统使用过程中，对系统的建议或需求反馈',
      // resptime: '10分钟',
      // finishtime: '3天内给予答复（电话、QQ、邮件）'
    }
  ],
  smartPlatform: "一键启用我的智慧实验室！",
  experienceNow: "立即体验",
  showCase: "客户案例",
  smartPlatform2: "你在等什么？赶紧启动你的智慧实验室吧",
  right:"© 2024-2025 江苏慧松信息科技有限公司          保留所有版权 | 苏ICP备20038957号-2 ",
  aggrement:"&nbsp;|&nbsp;用户协议",
  privacyPolicy:"&nbsp;|&nbsp;隐私政策",
  companyInfo:"我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼我们公司非常牛逼",
  contactUs: "联系我们",
  // 三个一组
  services: [
    ["实施培训","使用说明","演示视频"],
    ["用户协议","隐私政策"],
  ],
  address_title: "公司地址：",
  tel_title: "咨询电话：",
  qq_title: "客服QQ：",
  email_title: "公司邮箱：",
  address: "江苏省南京市⾬花台区软件大道118号新华汇B2栋5层",
  tel: "025-86751966",
  qq: "2546125360",
  email: "pinetech@126.com",
  homeTitle: "精工细作 · 智造未来",
  homeSubTitle: "打造以MES为核心的数字化工厂",
  more: "了解更多",
  techTitle:"环测链 智慧环境检测平台",
  techSubTitle:"真正强大的环境检测工作利器",
  techDesc:"为机加工行业提供生产加工的全过程（生产计划、生产准备、加工阶段、检验阶段、装配阶段、调试与检测、包装与交付）全要素（人、机、料、法、环）的数字化MOM系统解决方案。",
  techs:[
    {
      name:"全生命周期、全产业链的机加工服务",
      icon:"icon1.png",
      desc:"为机加工工厂提供从计划、加工到检验、发货的一整套数字化转型服务。",
    },
    {
      name:"“智能设备+工业互联+云服务”创新模式",
      icon:"icon2.png",
      desc:"以智能设备连接为基础,“设备层-车间层-网络层”三层联动，实现工业互联，云端服务。",
    },
    {
      name:"MOM+数控机床，软硬件双引擎驱动",
      icon:"icon3.png",
      desc:"以机加工MOM制造运营管理SaaS平台为软件核心，以数控机床为硬件核心，双引擎驱动，协同发展。",
    },
    {
      name:"SaaS模式，软件即服务，成本低",
      icon:"icon4.png",
      desc:"SaaS模式下，机加工厂可以低成本快速上线MOM软件，无需运维，还能免费享受软件的持续更新迭代，特殊需求支持独立部署。",
    },
  ],
  homeExpTitle:"机加工行业全过程全要素MOM平台",
  homeExpSubTitle:"“美而轻，专而精”",
  homeExpBtn:"马上体验",
  goOffer:"快速报价",
  preview:"观看演示",
  customerCaseTitle: "已有数十家环境检测机构选择智慧环境检测平台",
  companyInfo_case_1:`1.公司主营业务首先要写的是公司的主营业务，也就是你们的商业模式，用户群体，这些都可以简写。通俗点说就是你们是什么类型什么行业的企业，在什么地方做什么产品，
              靠什么盈利，用户群体是谁，提供什么价值，可以参考一个公式：XX公司是一家在（城市例如上海）的（行业例如跨境电商）公司，主要做（什么产品），主要用户/人群/客户是XX，
              给他们提供什么价值。`,
  companyInfo_case_2:`2.公司基本情况说明公司人员情况及其任职情况，注册资金，获得哪些荣誉，取得了哪些成绩，比如公司现有几个人，分别负责什么岗位。`,
  companyInfo_case_3:`3.提供价值详细说明你们公司的商业模式，用户群体，为他们提供的价值，这里就要具体分别展开描述了，是TOB业务还是TOC业务，详细说明这些业务，怎么做的，是否有成功案例，
              效果如何，比如小程序开发，是开发小程序模板，还是做小程序裂变的工具软件，还是做小程序活动策划的企业服务等，目前主要的客户群体有哪些，准备与哪些机构合作，
              取得了哪些成果，开展了什么活动等，目前的业务解决了哪些痛点，市场调研情况，竞品情况这些都可以简要提下。`,
  companyInfo_case_4:`4.公司的价值观和发展目标说明一下公司的发展愿景，未来发展目标，喊口号，企业文化等等。、`,

  company_case_info:  {
    name: "诚挚邀请您体验我们的产品",
    infos: [
      `目前已有数十家小型机加工工厂采用“智造大师”SaaS平台，以及多个中型工厂采用MES定制化系统，获得了用户的高度好评，也收到了很多反馈意见和建议，我们会持续迭代产品，为客户提供更好的使用体验。`
    ]
  },

  about_us_info: {
    name: "江苏慧松信息科技有限公司",
    // infos: [
    //   {title: '公司简介：', content:'江苏慧松信息科技有限公司成立于2020年8月，坐落于江苏省南京市江宁开发区。公司以区块链、物联网、大数据等新一代信息技术为基础，主要从事区块链应用开发、区块链平台运营等业务，公司聚焦于“区块链+实业”的应用场景，为客户提供区块链的细分行业应用，助力各行业降低成本、提升效率、升级模式，推动区块链技术深度赋能实体经济。'},
    //   {title: '公司定位：', content:'公司是以区块链、物联网、大数据等新一代信息技术为技术手段，为环境检测、数据采集等实体行业提供信息化管理平台及咨询服务的科技型企业。'},
    //   {title: '经营理念：', content:'打造出行业新技术与信息化运营策略相结合的创新实用产品，全心全意服务于我们的客户。'},
    //   {title: '公司愿景：', content:'致力成为行业首选、客户信赖的专业服务公司。'}
    // ]
  },
  product_service_slide_1_name:"环测链",
  product_service_slide_1_title:"环境监测机构全流程全要素管理平台",
  // product_service_slide_1_subtitle:"创新平台 环境监测机构的共同选择",
  product_service_slide_2_title_1: "智能化：",
  product_service_slide_2_desc_1: "通过管理平台实施整个环境监测整体业务流程；让组织中每位成员能够智能化管理业务!",
  product_service_slide_2_title_2: "平台化：",
  product_service_slide_2_desc_2: "将线下工作集中构建统一到管理平台，7大引擎满足业务流程的整体需求，实现按需应变！",
  product_service_slide_2_title_3: "全程电子化：",
  product_service_slide_2_desc_3: "电子报价单、电子合同、电子采样记录单、电子检测报告，彻底告别纸张办公，让组织在整个运营流程完全电子化！",


  product_service_slide_3_title:"智能工作台",
  product_service_slide_3_desc:"动态数据概览，风险预警提示",
  product_service_slide_3_info_1:"关键信息，一览无余",
  product_service_slide_3_info_2:"功能布局，因岗而异",
  product_service_slide_3_info_3:"界面友好，贴合习惯",
  product_service_slide_3_info_4:"管理风险，预警提示",
  // product_service_slide_3_info_5:"样品管理：样品电子化管理，状态实时监控",
  // product_service_slide_3_info_6:"检样管理：数据直观，准确可靠",
  // product_service_slide_3_info_7:"报告生成：一键自动生成，个性化编辑",


  product_service_slide_2_title:"生产管理",
  product_service_slide_2_desc:"全链路数字化管理，助力企业转型升级",
  product_service_slide_2_info_1:"<span style='font-weight:bold;'>工序设置：</span>对生产过程中的每个工序进行精细化管理，包括工序的划分、执行、监控和优化等。",
  product_service_slide_2_info_2:"<span style='font-weight:bold;'>生产报工：</span>实时收集和统计员工的工作完成情况，以便管理层及时掌握生产进度和员工绩效:",
  product_service_slide_2_info_3:"<span style='font-weight:bold;'>生产工单：</span>以工单为中心，实现生产任务的全面掌控，包括工单的创建、分配、执行和关闭等环节",
  product_service_slide_2_info_4:"<span style='font-weight:bold;'>生产排产：</span>采用数字化排程，合理安排生产计划和资源分配，确保生产顺利进行并降低成本。",

  product_service_slide_4_title:"服务对象",
  product_service_slide_4_desc:"便捷报价，快速生成全面准确的报价单",
  product_service_slide_4_info_1:"零部件加工企业、原材料加工企业、整机加工企业、模具加工企业等中小型机加工企业。",
  product_service_slide_4_info_2:"平台功能:",
  product_service_slide_4_info_3:"为机加工行业提供生产加工的全过程(生产计划、生产准备、加工阶段、检验阶段、装配阶段、调试与检测、包装与交付)全要素(人、机、料、法、环)的数字化MOM系统解决方案。",
  product_service_slide_4_info_4:"结合众多机加工企业的特点及数字化工厂的建设需求，针对机加工厂在计划排产、调度管理、物料配套、工艺管理、作业执行、数据采集、质量检验、资源管理、在制品管理、追湖管理、看板和报表等核心功能，帮助工厂实现精益管理和透明化管理。",

  product_service_slide_5_title:"排班管理",
  product_service_slide_5_desc:"智能化排班，灵活性调整",
  product_service_slide_5_info_1:"<span style='font-weight:bold;'>支持多种排班方式：</span>设置工厂常用的两班两倒、三班两倒排班方式，满足不同工厂的排班需求。",
  product_service_slide_5_info_2:"<span style='font-weight:bold;'>自由设置班组成员及轮班周期：</span>用户可以根据每个班组的特定需求，对班组成员和轮班周期进行灵活设置。",
  product_service_slide_5_info_3:"<span style='font-weight:bold;'>灵活设置节假日及休息日：</span>用户可以根据实际情况设置节假日和休息日，并可以灵活调整这些日期，提高了系统的适应性，",
  product_service_slide_5_info_4:"<span style='font-weight:bold;'>自动生成排班日历并支持调班：</span>系统根据排班情况自动生成排班日历，也可以根据需要进行调整，使得排班更加灵活和高效。",

  product_service_slide_6_title:"质量管理",
  product_service_slide_6_desc:"自定义质检标准，高度匹配不同需求",
  product_service_slide_6_info_1:"<span style='font-weight:bold;'>自定义质检标准：</span>企业可以根据自身需求，在系统中自行设置和调整质量标准和检测流程",
  product_service_slide_6_info_2:"<span style='font-weight:bold;'>严格把控质量过程：</span>支持来料检验、首检、巡检、抽检、入库检验等质量过程控制，防止漏检或错检，可针对不同缺陷项目，进行质量闭环处理",
  product_service_slide_6_info_3:"<span style='font-weight:bold;'>全面质量分析预警：</span>系统通过对产品生产过程中的各种数据和指标进行实时监测和分析，及时发现并预警产品质量问题。",



  product_service_slide_7_title:"仓储管理",
  product_service_slide_7_desc:"仓储管理线上化，作业流程标准化",
  product_service_slide_7_info_1:"默认“线边库”",
  product_service_slide_7_info_2:"支持条码打印及扫描",
  product_service_slide_7_info_3:"用于统计整个工厂在制物资的库存情况。基于库区库位的分级仓库管理。",
  product_service_slide_7_info_4:"快速精准完成物资出入库登记，库存量即时更新。",

  product_service_slide_8_title:"CAD管理",
  product_service_slide_8_desc:"管理和追踪设计文档及其变化",
  product_service_slide_8_info_1:"<span style='font-weight:bold;opacity:0.8;'>联网设备的代码程序远程更新：",
  product_service_slide_8_info_2:"<span style='font-weight:bold;opacity:0.8;'>通过远程连接，实时更新和优化设备软件及固件程序。",
  product_service_slide_8_info_3:"<span style='font-weight:bold;opacity:0.8;'>模型、图纸、标准等文件管理：",
  product_service_slide_8_info_4:"<span style='font-weight:bold;opacity:0.8;'>创建、编辑、组织和维护产品设计、工程和制造文档。",



  product_service_slide_9_title:"设备管理",
  product_service_slide_9_desc:"全生命周期管理，精细备件管理",
  product_service_slide_9_info_1:"<span style='font-weight:bold;'>设备台账：</span>录设备的全面信息，为设备管理提供基础数据。",
  product_service_slide_9_info_2:"<span style='font-weight:bold;'>点巡检：</span>期或不定期检查设备，确保其正常运行，及时发现并解决问题。",
  product_service_slide_9_info_3:"<span style='font-weight:bold;'>设备保养：</span>期保养设备，保持其良好状态，预防性维护。",
  product_service_slide_9_info_4:"<span style='font-weight:bold;'>设设备检修：</span>在设备使用一段时间后进行全面检查和维护，修复故障，确保设备的可靠性和安全性。",


  product_service_slide_10_title:"刀具管理",
  product_service_slide_10_desc:"全生命周期管理，实现生产执行与准备的分离",
  product_service_slide_10_info_1:"刀具信息管理",
  product_service_slide_10_info_2:"刀具位置调度管理",
  product_service_slide_10_info_3:"刀具特殊属性管理",


  product_service_slide_11_title:"统计分析",
  product_service_slide_11_desc_1:`动态数据概览，掌握实时生产进度`,
  product_service_slide_11_desc_2: `<span style='font-weight:bold;'>生产数据统计分析：</span>收集和分析生产过程中的各种数据，如产量、质量、效率等，帮助企业更好地了解生产状况。`,
  product_service_slide_11_desc_3: "<span style='font-weight:bold;'>智能看板实时把控生产进度：</span>通过实时的数据更新和可视化的看板展示，帮助企业更好地调度资源，调整生产计划，并提高生产效率。",
  product_service_slide_11_desc_4: "<span style='font-weight:bold;'>生产成本、人员薪资自动汇总统计：</span>帮助企业自动汇总和统计生产过程中的物料成本、设备折旧、人员薪资等，帮助企业了解生产成本的结构，制定更加合理的定价策略。",
  
  product_service_slide_12_title:"工装夹具管理",
  product_service_slide_12_desc:"建立工装夹具台账，构建计划性维保体系",
  product_service_slide_12_info_1:"<span style='font-weight:bold;'>完整的工装夹具管理台账：</span>建立详细的工装夹具台账，记录工装夹具的名称、规格、数量、用途等信息，方便查询和管理。",
  product_service_slide_12_info_2:"<span style='font-weight:bold;'>领用归还管理：</span>通过工装夹具的领用和归还流程，确保工装夹具的正确使用和及时归还，避免浪费和丢失。",
  product_service_slide_12_info_3:"<span style='font-weight:bold;'>设备保养：</span>期保养设备，保持其良好状态，预防性维护。",
  product_service_slide_12_info_4:"<span style='font-weight:bold;'>维保报废管理：</span>对工装夹具进行定期的维护保养，及时处理损坏和无法修复的工装夹具，延长其使用寿命，提高生产效率。",

  product_service_slide_13_title:"高精度视觉测量与检测系统(需定制)",
  product_service_slide_13_desc:"高精度测量，自动化检测",

  product_service_slide_13_title_1:"零件的轮廓原图",
  product_service_slide_13_desc_2:"直接从零件实物或者设计软件中获取的零件形状图片，包含了零件的全部细节和轮廓。",
  product_service_slide_13_title_3:"零件的轮廓处理图",
  product_service_slide_13_desc_4:"通过图像处理技术，对原图进行去噪、增强等操作，以突出零件的轮廓特征，并消除或减少原图中存在的干扰和噪声，",
  product_service_slide_13_title_5:"3D相机扫描的单个齿点云图",
  product_service_slide_13_desc_6:"通过3D相机对零件的特定区域进行扫描，可以获取到该区域的点云数据。这些数据描述了该区域的形状、大小、位置等信息。通过对这些数据的分析，可以检测出零件的质量、精度以及是否存在缺陷等。",






};

export default constant;



// WEBPACK FOOTER //
// ./src/constant/constant.js